/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/PlaylistComplete.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import formatFriendlyName from 'I18n/utils/formatFriendlyName';
import { View } from 'foundations-components/components/View';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import FinishedContainer from '../../../components/FinishedContainer.migrated';
import { usePlaylistIdFromSearch } from '../hooks.migrated';
import { useUserInfo } from '../../accounts/accountsQueries.legacy';
import { usePlaylist } from '../../savedItems/savedItemsQueries.migrated';
import { getSearchUrl } from '../../search/searchRouting.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/PlaylistComplete.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const PlaylistComplete = ({
  navMarkerName
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);
  const {
    userInfo
  } = useUserInfo();
  const body = playlist && userInfo && /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.completePlaylistContent.completeTitle",
        options: {
          name: formatFriendlyName({
            givenName: userInfo.user.firstName,
            familyName: userInfo.user.lastName
          })
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.completePlaylistContent.completeSubtitle"
      })
    })]
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: /*#__PURE__*/_jsx(FinishedContainer, {
        body: body,
        footer: /*#__PURE__*/_jsx(ACRouterButton, {
          to: getSearchUrl({
            contentType: 'LEARNING_PATH'
          }),
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlistContent.completePlaylistContent.completeCta"
          })
        }),
        illustration: /*#__PURE__*/_jsx(Pictogram, {
          name: "CelebrationSuccess"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: body,
    footer: /*#__PURE__*/_jsx(ACRouterButton, {
      to: getSearchUrl({
        contentType: 'LEARNING_PATH'
      }),
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.completePlaylistContent.completeCta"
      })
    }),
    illustration: /*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    })
  });
};